// project-imports
import { deleteRequest, getRequest, postRequest } from 'utils/action-manager/actionManager';
import { APIAction } from '../apiManager';

// ==============================|| API MANAGER - DT COMMERCIAL ||============================== //

export async function handleDTCommercial(action: APIAction) {
  switch (action.method) {
    case 'list':
      return getRequest('/dt-commercial/list');
    case 'list-admin':
      return getRequest('/dt-commercial/list-admin');
    case 'create-update':
      return postRequest(`/dt-commercial`, action.data);
    case 'delete':
      return deleteRequest(`/dt-commercial/${action.id}`);
    default:
      console.info('[ApiManager > handleApiAction > handleDTCommercial] - Unknown method');
      break;
  }
}
